<template>
	<div class="flex" style="width: 100%;position: relative;flex-direction: row;align-items: center;">
		<van-field :class="{penetrate:penetrate}" @click="penetrate?preview:''" :readonly="readonly || disabled" :required="formCreateInject.rule.validate[0].required"
			:value="value" :label="formCreateInject.prop.title.title" placeholder="" @input="change"
			input-align="right">
			<template #left-icon>
				<van-icon v-if="alwaysShow || !readonly && !disabled" name="edit" color="#07c160" />
			</template>
		</van-field>
		<template v-if="alwaysShow || !readonly && !disabled">
			<van-button type="info" color="#ffffff" @click="buttonClick">
				<template #default>
					<van-icon name="search" color="#1989fa" size="20px" />
				</template>
			</van-button>
		</template>
		<component ref="componentRef" :is="penetrateComponentConfig.component" v-bind="penetrateComponentConfig.props"
			v-if="penetrateComponentConfig" />
	</div>

</template>
<style scoped>
	.inputbutton {
		border-radius: 0px;
		box-sizing: border-box;
		border-left: 0px;
		position: relative;
		padding: 7px 8px;
	}
</style>
<script>
	import penetrate from '@_system/components/base/mixins/penetrate/penetrate.js'
	import selectBase from '@_system/components/base/select.js'
	export default {
		mixins: [selectBase,penetrate],
		props: {
			icon: {
				type: String,
				default: () => {
					return 'el-icon-search'
				}
			},
			alwaysShow: {
				default: () => {
					return true
				}
			}
		},
		data() {
			return {
				loading: false
			}
		},
		created() {


		},
		mounted() {

		},
		watch: {

		},
		computed: {

		},
		methods: {
			buttonClick() {
				if ((this.alwaysShow || !this.readonly && !this.disabled) && !this.loading) {
					this.$emit('inputButtonclick',{
						el: this
					})
				}
			},
			change(val) {
				this.$emit('input', Object.hasOwn(val, 'value') ? val.value : val)
			},
		},
		components: {

		},
	}
</script>
